import React from 'react';
import { Spacer, Text } from '@ontruck/orc';
import arrowRenderer from './arrowRenderer';
import { CarrierLink, DriverLink } from './idLink';

const vehicleArrowRenderer = ({
  vehicle_plate_number_before,
  vehicle_plate_number_after,
  trailer_plate_number_before,
  trailer_plate_number_after,
}) => {
  return (
    <>
      {vehicle_plate_number_before}{' '}
      {!!trailer_plate_number_before && <>+ {trailer_plate_number_before}</>}{' '}
      {(vehicle_plate_number_before || trailer_plate_number_before) && <>&#8594;</>}{' '}
      {vehicle_plate_number_after}{' '}
      {!!trailer_plate_number_after && <> + {trailer_plate_number_after}</>}
    </>
  );
};

const Assign = ({
  changes: {
    carrier_id_before,
    carrier_id_after,
    driver_id_before,
    driver_id_after,
    carrier_name_before,
    carrier_name_after,
    driver_name_before,
    driver_name_after,
    vehicle_plate_number_before,
    vehicle_plate_number_after,
    trailer_plate_number_before,
    trailer_plate_number_after,
  },
  ...props
}) => {
  return (
    <Spacer {...props}>
      {carrier_name_before !== carrier_name_after && (
        <Text color="grey800" display="block">
          {arrowRenderer(
            !!carrier_name_before && (
              <CarrierLink id={carrier_id_before} text={carrier_name_before} />
            ),
            <CarrierLink id={carrier_id_after} text={carrier_name_after} />
          )}
        </Text>
      )}
      {driver_name_before !== driver_name_after && (
        <Text color="grey800" display="block">
          {arrowRenderer(
            !!driver_name_before && (
              <DriverLink
                carrier_id={carrier_id_before}
                driver_id={driver_id_before}
                text={driver_name_before}
              />
            ),
            <DriverLink
              carrier_id={carrier_id_after}
              driver_id={driver_id_after}
              text={driver_name_after}
            />
          )}
        </Text>
      )}
      {(vehicle_plate_number_before !== vehicle_plate_number_after ||
        trailer_plate_number_before !== trailer_plate_number_after) && (
        <Text color="grey800" display="block">
          {vehicleArrowRenderer({
            vehicle_plate_number_before,
            vehicle_plate_number_after,
            trailer_plate_number_before,
            trailer_plate_number_after,
          })}
        </Text>
      )}
    </Spacer>
  );
};

export default Assign;
